'use strict';

const constants = require('./constants/constants');
self.importScripts(constants.LODASH);

const ravenWorkerServices = require('./ravenWorkerServices');
ravenWorkerServices.initRavenWorkerServices();

const MessageType = require('./wixCodeMessageTypes');
const errors = require('./errors');
const workerUtils = require('./worker/workerUtils');
const renderHandler = require('./worker/renderHandler');
const loadUserCodeHandler = require('./worker/loadUserCodeHandler');
const loadUserGeneratedAppsHandler = require('./worker/loadUserGeneratedAppsHandler');
const UserCodeStore = require('./worker/UserCodeStore');
const AppsStore = require('./stores/AppsStore');
const Store = require('./stores/store');
const MessageService = require('./worker/services/MessageService');
const wixCodeViewerApp = require('./wixCodeViewerApp');
const experiments = require('./stores/selectors/experiments');
const { USE_WIX_CODE_APP_EXPERIMENT } = require('./constants/constants');

const scriptsHandler = require('./worker/scriptHandler');
const PubSubService = require('./worker/services/PubSubService.js');

const handlersCreator = require('./worker/handlersCreator');

const _ = require('lodash');

const store = new Store();
const messageService = new MessageService();
const pubSubService = new PubSubService(messageService);
let sdk;

const { bootstrap, load, init, start } = handlersCreator.create({ store, messageService, pubSubService });
const initOnce = _.once(init);
const startOnce = _.once(start);
const loadOnce = _.once(load);
const handleRenderedOnce = _.once(renderHandler.handle);
const {setElementoryArguments} = require('./worker/elementoryArguments');
const handleScriptImport = scriptsHandler.handleScript;

const MAX_FETCH_DELAY = 500;

const userCodeStore = new UserCodeStore();
const appsStore = new AppsStore();
let workerId = null;
let bootstrapArgs = null;
const getEnv = () => _.get(bootstrapArgs, ['sdkParameters', 'renderingEnv'], 'browser');

const ravenOnErrorCb = self.onerror;

self.onerror = function onError(message, filename, lineno, colno, err) {
  ravenOnErrorCb.apply(this, arguments);
  self.console.error(err ? err : message);
  workerUtils.reportBI(errors.PLATFORM_LIFECYCLE_UNHANDLED_EXCEPTION, {
    errorMsg: message,
    stack: err && err.stack,
    line: lineno,
    column: colno
  });
};

let messages = [];
let fetchScriptsCount = 0;

self.onmessage = message => {
  if (!message.data) {
    return;
  }

  if (message.data.type === MessageType.SCRIPT_IMPORT_MESSAGE) {
    handleScriptImport(message.data);
    if (--fetchScriptsCount === 0) {
      flushMessages();
      return;
    }
  }

  messages.push(message);
  if (message.data.type === MessageType.BOOTSTRAP) {
    if (message.data.fetchScriptsCount) {
      fetchScriptsCount = message.data.fetchScriptsCount;
      setTimeout(flushMessages, MAX_FETCH_DELAY);
    } else {
      flushMessages();
    }
  }
};

function flushMessages() {
  if (messages) {
    self.onmessage = processMessage;
    messages.forEach(processMessage);
    messages = null;
  }
}

function processMessage(message) {
  if (!message.data) {
    return;
  }

  if (message.data.type === MessageType.BOOTSTRAP) {
    sdk = bootstrap(message.data, appsStore);
    bootstrapArgs = message.data.bootstrapArguments;
  } else if (message.data.type === MessageType.START) {
    const handleStart = message.data.livePreviewMode ? start : startOnce;
    handleStart(message.data, {
      workerId,
      getAllApps: appsStore.getAll.bind(appsStore),
      env: getEnv(),
      sdk
    });
  }

  if (sdk) {
    switch (message.data.type) {
      case MessageType.LOAD_USER_CODE:
        loadUserCodeHandler.handleLoadUserCode(message.data, {userCodeStore, store});
        break;
      case MessageType.LOAD_USER_GENERATED_APPS:
        loadUserGeneratedAppsHandler.loadUserGeneratedApps(message.data, appsStore);
        break;
      case MessageType.LOAD:
        workerId = message.data.workerId;
        loadOnce(message.data, {
          workerId,
          getApp: appsStore.get.bind(appsStore),
          userCodeStore,
          sdk
        });
        break;
      case MessageType.INIT:
        const _init = message.data.livePreviewMode ? init : initOnce;
        _init(message.data, {
          workerId,
          getApp: appsStore.get.bind(appsStore),
          sdk
        });
        break;
      case MessageType.PAGE_RENDERED:
        const handleRendered = message.data.livePreviewMode ? renderHandler.handle : handleRenderedOnce;
        handleRendered(sdk);
        break;
      case MessageType.UPDATE_WIX_CODE_DATA_AFTER_LOGIN:
        const useWixCodeApp = experiments.isExperimentOpen(store, USE_WIX_CODE_APP_EXPERIMENT);
        if (useWixCodeApp) {
          wixCodeViewerApp.updateWixCodeData({elementoryArguments: message.data.elementoryArguments});
        } else if (message.data.elementoryArguments) {
          setElementoryArguments(message.data.elementoryArguments);
        }
        break;
      case MessageType.SCRIPT_IMPORT_MESSAGE:
        break;
      case MessageType.STOP:
        self.close();
        break;
      case MessageType.INVOKE_WORKER_SUBSCRIBERS:
        pubSubService.handlePubSubMessage(message.data);
        break;
      default:
        delegateMessageToSDK(message);
        break;
    }
  }
}

function delegateMessageToSDK(message) {
  if (sdk) {
    sdk.__INTERNAL__.onMessage(message);
  }
}
